// extracted by mini-css-extract-plugin
module.exports = {"root":"VolumeSeek_root__8QHbJ","seekWrapper":"VolumeSeek_seekWrapper__qhRaN","seek":"VolumeSeek_seek__W4ySx"};